import { render, staticRenderFns } from "./news-tooltip.html?vue&type=template&id=902de4e8&scoped=true&external"
import script from "./news-tooltip.ts?vue&type=script&lang=ts&external"
export * from "./news-tooltip.ts?vue&type=script&lang=ts&external"
import style0 from "./news-tooltip.scss?vue&type=style&index=0&id=902de4e8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902de4e8",
  null
  
)

/* custom blocks */
import block0 from "./news-tooltip.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Ftasks%2FtblUpdateNews%2Fnews-tooltip%2Fnews-tooltip.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports